import { render, staticRenderFns } from "./TasksPopup.vue?vue&type=template&id=5a6f39f2&scoped=true"
import script from "./TasksPopup.vue?vue&type=script&lang=js"
export * from "./TasksPopup.vue?vue&type=script&lang=js"
import style0 from "./TasksPopup.vue?vue&type=style&index=0&id=5a6f39f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6f39f2",
  null
  
)

export default component.exports